"use client"

import { convertToLocale } from '@/lib/helpers/money';
import { useTranslate } from '@tolgee/react';

export const CartItemsFooter = ({
  currency_code,
  price,
}: {
  currency_code: string;
  price: number;
}) => {
  const { t } = useTranslate();
  return (
    <div className='border text-[#1A1A1A] rounded-bl-[12px] rounded-br-[12px] py-[12px] px-[20px] flex items-center justify-between label-md bg-[rgba(240,240,240,0.3)]'>
      <p className='text-[#8C8C8C]'>{t("cart.delivery")}</p>
      <p>
        {convertToLocale({
          amount: price / 1,
          currency_code,
        })}
      </p>
    </div>
  );
};
